exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mypage_reserve_list_window[data-v-0fe4eea0]{\n    width: 95%;\n    max-width: 1100px;\n    min-width: 800px;\n}\n.mypage_member_info_window[data-v-0fe4eea0]{\n    width: 35%;\n    max-width: 850px;\n    min-width: 700px;\n}\n@media screen and (max-width: 896px) {\n.mypage_member_info_window[data-v-0fe4eea0]{\n        width: 95%;\n        max-width: initial;\n        min-width: initial;\n}\n.mypage_reserve_list_window[data-v-0fe4eea0] {\n        width: 92%;\n        max-width: initial;\n        min-width: initial;\n}\n}\n", ""]);

// exports
